class CustomizerCollectionModalSlider {
  constructor() {
    this.selectedProducts = new Map(); // Store selected products with quantities
    this.isFiltered = false; // Track if slider is currently filtered
    this.init();
  }

  init() {
    this.initializeSliders();
    this.initializeDefaultFilter();
    this.setupEventListeners();
  }

  initializeSliders() {
    // Initialize slick slider for all product-slider elements
    const productSliders = document.querySelectorAll('.product-slider');
    productSliders.forEach((slider) => {
      // Check if slider is already initialized
      const isAlreadyInitialized = $(slider).hasClass('slick-initialized');
      if (!isAlreadyInitialized) {
        // Wait for the first image to load to prevent flicker
        const firstImage = slider.querySelector('img');
        if (firstImage && firstImage.complete && firstImage.naturalHeight !== 0) {
          this.initializeSingleSlider(slider);
        } else if (firstImage) {
          firstImage.addEventListener('load', () => {
            this.initializeSingleSlider(slider);
          });
          firstImage.addEventListener('error', () => {
            this.initializeSingleSlider(slider);
          });
        } else {
          // No images found, initialize immediately
          this.initializeSingleSlider(slider);
        }
      }
    });
  }

  initializeSingleSlider(slider) {
    $(slider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      adaptiveHeight: false,
      variableWidth: false,
      centerMode: true,
      centerPadding: '25%',
      focusOnSelect: false,
      waitForAnimate: false,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="36" viewBox="0 0 21 36" fill="none"><path d="M19.5 34L3.5 18L19.5 2" stroke="#E00F00" stroke-width="4"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="36" viewBox="0 0 21 36" fill="none"><path d="M1.5 2L17.5 18L1.5 34" stroke="#E00F00" stroke-width="4"/></svg></button>'
    });
    
    // Add event listener for slide changes
    $(slider).on('afterChange', (event, slick, currentSlide) => {
      this.updateProgressBarsForActiveSlide(slider, currentSlide);
    });

    // Initialize progress bars for the first slide
    this.updateProgressBarsForActiveSlide(slider, 0);
  }

  initializeDefaultFilter() {    
    // Set the first toggle label as active by default
    const firstToggleLabel = document.querySelector('.product-toggle__label');
    if (firstToggleLabel && !document.querySelector('.product-toggle__label--active')) {
      firstToggleLabel.classList.add('product-toggle__label--active');
    }
    
    // Find the active toggle option and apply the filter automatically
    const activeToggleOption = document.querySelector('.product-toggle__label--active');
    
    if (activeToggleOption) {
      const filterValue = activeToggleOption.dataset.filter;
      
      // Set the current filter state and apply the default filter
      this.currentFilter = filterValue;
      this.isFiltered = true;
      
      // Apply the default filter after a short delay to ensure sliders are initialized
      setTimeout(() => {
        this.filterSlider(filterValue);
      }, 200);
    }
  }

  setupEventListeners() {
    document.addEventListener('click', (event) => {
      // Handle Add to Cart button clicks
      if (event.target.closest('.slider-card__actions-atc')) {
        event.preventDefault();
        const button = event.target.closest('.slider-card__actions-atc');
        const sliderCard = button.closest('.slider-card');
        this.addProductToSelected(sliderCard);
      }
      
      // Handle quantity increase/decrease buttons
      else if (event.target.closest('.slider-card__actions-qty button')) {
        event.preventDefault();
        const button = event.target.closest('.slider-card__actions-qty button');
        const sliderCard = button.closest('.slider-card');
        const input = sliderCard.querySelector('.slider-card__actions-qty input');
        const currentValue = parseInt(input.value) || 1;
        
        if (button.textContent === '+') {
          input.value = currentValue + 1;
        } else if (button.textContent === '-' && currentValue > 1) {
          input.value = currentValue - 1;
        }
        
        // Update the selected product quantity
        this.updateSelectedProductQuantity(sliderCard);

        // Update quantity button states
        this.updateQuantityButtonStates(sliderCard);
      }
      
      // Handle quantity input changes
      else if (event.target.closest('.slider-card__actions-qty input')) {
        const input = event.target;
        const sliderCard = input.closest('.slider-card');
        
        // Validate and enforce minimum value of 1
        this.validateQuantityInput(input);
        
        // Update the selected product quantity
        this.updateSelectedProductQuantity(sliderCard);
        // Update quantity button states
        this.updateQuantityButtonStates(sliderCard);
      }
      
      // Handle remove product from selected
      else if (event.target.closest('.selected-product-card__remove')) {
        event.preventDefault();
        const removeButton = event.target.closest('.selected-product-card__remove');
        const selectedProductCard = removeButton.closest('.selected-product-card');
        const variantId = selectedProductCard.dataset.variantId;
        this.removeProductFromSelected(variantId);
      }
      
      // Handle product toggle option clicks
      else if (event.target.closest('.product-toggle__option')) {
        event.preventDefault();
        const toggleOption = event.target.closest('.product-toggle__option');
        this.toggleProductOption(toggleOption);
      }
      
      // Handle product toggle label clicks
      else if (event.target.closest('.product-toggle__label')) {
        event.preventDefault();
        const clickedLabel = event.target.closest('.product-toggle__label');
        this.toggleProductOptionFromLabel(clickedLabel);
      }
    });

    // Add additional event listeners for quantity input validation
    document.addEventListener('blur', (event) => {
      if (event.target.closest('.slider-card__actions-qty input')) {
        const input = event.target;
        const sliderCard = input.closest('.slider-card');
        
        // Validate and enforce minimum value of 1 on blur
        this.validateQuantityInput(input);
        
        // Update the selected product quantity
        this.updateSelectedProductQuantity(sliderCard);

        // Update quantity button states
        this.updateQuantityButtonStates(sliderCard);
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.target.closest('.slider-card__actions-qty input')) {
        const input = event.target;
        const currentValue = parseInt(input.value) || 1;
        
        // Prevent minus key if value is already 1
        if (event.key === '-' && currentValue <= 1) {
          event.preventDefault();
        }
        
        // Prevent zero key if value is already 1
        if (event.key === '0' && currentValue <= 1) {
          event.preventDefault();
        }
      }
    }, true);
  }

  // Remove all products from selected products
  removeAllProductsFromSelected(stepId) {
    this.selectedProducts.forEach((variant, variantId) => {
      if (variant.stepId === stepId) {
        this.removeProductFromSelected(variantId);
      }
    });
  }

  // Add product to selected products
  addProductToSelected(sliderCard) {
    const modal = document.querySelector('.customizer-product-modal[style*="block"]');
    const modalId = modal.getAttribute('id');
    const variantTitle = sliderCard.querySelector('.slider-card__content-title').dataset.variantTitle;
    const variantPrice = sliderCard.querySelector('.slider-card__content-price').textContent.trim();
    const variantImage = sliderCard.querySelector('.slider-card__image-img').src;
    const quantityInput = sliderCard.querySelector('.slider-card__actions-qty input');
    const quantity = parseInt(quantityInput.value) || 1;
    const variantId = sliderCard.dataset.variantId;
    const productId = sliderCard.dataset.productId;
    const stepId = sliderCard.dataset.stepId;

    // Check if multiple modal selections are allowed
    const allowMultipleModalSelections = modal.dataset.allowMultipleModalSelections !== 'false';

    if (!allowMultipleModalSelections) {
      // Remove all products from selected products
      this.removeAllProductsFromSelected(stepId);
    }
    
    // Store variant data
    this.selectedProducts.set(variantId, {
      stepId: stepId,
      modalId: modalId,
      title: variantTitle,
      price: variantPrice,
      image: variantImage,
      quantity: quantity,
      variantId: variantId,
      productId: productId
    });
    
    // Update main customizer step selections
    if (window.customizer && stepId) {
      // Check if this step allows multiple selections
      const stepElement = document.querySelector(`.step[data-step-id="${stepId}"]`);
      const allowMultiple = stepElement ? stepElement.dataset.allowMultiple === 'true' : true;
      
      window.customizer.updateStepSelection(stepId, variantId, true, allowMultiple);
      // Hide step error when product is selected
      window.customizer.hideStepError(stepId);
    }
    
    this.updateSelectedProductsDisplay();
    this.updateAddButtonState(sliderCard, true);
    this.updateApplyButton();
    
    // Update add to cart price in real-time
    if (window.customizer && window.customizer.updateAddToCartPrice) {
      window.customizer.updateAddToCartPrice(true);
    }
  }

  // Remove product from selected products
  removeProductFromSelected(variantId) {
    // Get the step ID before removing the product
    const sliderCards = document.querySelectorAll('.slider-card');
    let stepId = null;
    sliderCards.forEach(card => {
      const cardVariantId = card.dataset.variantId;
      if (cardVariantId === variantId) {
        stepId = card.dataset.stepId;
        this.updateAddButtonState(card, false);
      }
    });
    
    this.selectedProducts.delete(variantId);
    
    // Update main customizer step selections
    if (window.customizer && stepId) {
      // Check if this step allows multiple selections
      const stepElement = document.querySelector(`.step[data-step-id="${stepId}"]`);
      const allowMultiple = stepElement ? stepElement.dataset.allowMultiple === 'true' : true;
      
      window.customizer.updateStepSelection(stepId, variantId, false, allowMultiple);
    }
    
    this.updateSelectedProductsDisplay();
    this.updateApplyButton();
    
    // Update add to cart price in real-time
    if (window.customizer && window.customizer.updateAddToCartPrice) {
      window.customizer.updateAddToCartPrice(true);
    }
  }

  // Update selected product quantity
  updateSelectedProductQuantity(sliderCard) {
    const variantId = sliderCard.dataset.variantId;
    const quantityInput = sliderCard.querySelector('.slider-card__actions-qty input');
    const quantity = parseInt(quantityInput.value) || 1;
    
    if (this.selectedProducts.has(variantId)) {
      // Update the quantity in the selected products
      const variant = this.selectedProducts.get(variantId);
      variant.quantity = quantity;
      this.selectedProducts.set(variantId, variant);
      
      // Update the display
      this.updateSelectedProductsDisplay();
      
      // Update add to cart price in real-time
      if (window.customizer && window.customizer.updateAddToCartPrice) {
        window.customizer.updateAddToCartPrice(true);
      }
    }
  }

  // Update the selected products display
  updateSelectedProductsDisplay() {
    const wrapper = document.querySelector('.selected-products-wrapper');
    const noProductsMessage = wrapper.querySelector('.no-selected-products');
    const selectedProducts = wrapper.querySelector('.selected-products');
    const selectedProductsCards = wrapper.querySelector('.selected-products-cards');
    const selectedProductsSummary = wrapper.querySelector('.selected-products-summary');

    if (this.selectedProducts.size === 0) {
      noProductsMessage.classList.remove('no-selected-products--hidden');
      selectedProducts.classList.remove('selected-products--visible');
    } else {
      noProductsMessage.classList.add('no-selected-products--hidden');
      selectedProducts.classList.add('selected-products--visible');
      
      // Update count and total
      let totalCount = 0;
      let totalPrice = 0;
      
      this.selectedProducts.forEach((variant) => {
        totalCount += variant.quantity;

        // Parse price correctly handling both European (comma) and standard (period) decimal separators
        const priceValue = this.parsePrice(variant.price);
        totalPrice += priceValue * variant.quantity;
      });

      // Format price based on country (GBP for UK, EUR for others)
      const formattedPrice = this.formatCurrency(totalPrice);

      // Update summary
      selectedProductsSummary.innerHTML = `${totalCount} Ring${ totalCount > 1 ? 's' : '' } Selected <span class="selected-products-total-price">+ ${formattedPrice}</span>`;
      
      // Update selected product cards
      this.renderSelectedProductCards(selectedProductsCards);
    }
  }

  // Render selected product cards
  renderSelectedProductCards(container) {
    // Remove existing product cards (keep summary and structure)
    const existingCards = container.querySelectorAll('.selected-product-card');
    existingCards.forEach(card => card.remove());
    
    // Add new product cards
    this.selectedProducts.forEach((variant, variantId) => {
      const productCard = document.createElement('div');
      productCard.className = 'selected-product-card';
      productCard.dataset.variantId = variantId;
      
      productCard.innerHTML = `
        <div class="selected-product-card__content">
          <img class="selected-product-card__image" src="${variant.image}" alt="${variant.title}">
          <p class="selected-product-card__title">${variant.title} (${variant.quantity})</p>
        </div>
        <button type="button" class="button grey selected-product-card__remove"><span>&times;</span></button>
      `;
      
      container.appendChild(productCard);
    });
  }

  // Validate and sanitize quantity input
  validateQuantityInput(input) {
    let value = parseInt(input.value) || 1;
    
    // Ensure minimum value of 1
    if (value < 1) value = 1;
    
    // Update the input value if it was changed
    if (parseInt(input.value) !== value) {
      input.value = value;
    }
    
    return value;
  }

  // Update quantity button states
  updateQuantityButtonStates(sliderCard) {
    const qtyContainer = sliderCard.querySelector('.slider-card__actions-qty');
    if (!qtyContainer) return;
    
    const input = qtyContainer.querySelector('input');
    const decreaseButton = qtyContainer.querySelector('button:first-child');
    const increaseButton = qtyContainer.querySelector('button:last-child');
    
    if (input && decreaseButton && increaseButton) {
      const currentValue = parseInt(input.value) || 1;
      
      // Disable decrease button when value is 1
      currentValue <= 1 ? decreaseButton.disabled = true : decreaseButton.disabled = false;
    }
  }

  // Update add button state
  updateAddButtonState(sliderCard, isSelected) {
    const button = sliderCard.querySelector('.slider-card__actions-atc');
    const qtyContainer = sliderCard.querySelector('.slider-card__actions-qty');
    const variantId = sliderCard.dataset.variantId;
    
    if (isSelected && this.selectedProducts.has(variantId)) {
      // Hide the add button and show quantity input
      button.classList.add('slider-card__actions-atc--hidden');
      qtyContainer.classList.add('slider-card__actions-qty--visible');
      
      // Update quantity button states
      this.updateQuantityButtonStates(sliderCard);
    } else {
      // Show the add button and hide quantity input
      button.classList.remove('slider-card__actions-atc--hidden');
      qtyContainer.classList.remove('slider-card__actions-qty--visible');
      button.classList.remove('selected');
      button.querySelector('span').textContent = 'Add';
    }
  }

  // Toggle product option
  toggleProductOption(clickedOption) {
    const productToggle = clickedOption.closest('.product-toggle');
    const allOptions = productToggle.querySelectorAll('.product-toggle__option');
    const allLabels = productToggle.querySelectorAll('.product-toggle__label');
    const filterValue = clickedOption.dataset.filter;
    
    // Remove active class from all options and labels
    allOptions.forEach(option => {
      option.classList.remove('product-toggle__option--active');
    });

    allLabels.forEach(label => {
      label.classList.remove('product-toggle__label--active');
    });
    
    // Add active class to clicked option
    clickedOption.classList.add('product-toggle__option--active');
    
    // Find the corresponding label and add active class
    const optionIndex = Array.from(allOptions).indexOf(clickedOption);
    if (allLabels[optionIndex]) {
      allLabels[optionIndex].classList.add('product-toggle__label--active');
    }

    // Apply filter to the slider
    this.filterSlider(filterValue);
  }

  // Toggle product option from label click
  toggleProductOptionFromLabel(clickedLabel) {
    const productToggle = clickedLabel.closest('.product-toggle');
    const allOptions = productToggle.querySelectorAll('.product-toggle__option');
    const allLabels = productToggle.querySelectorAll('.product-toggle__label');
    
    // Find the index of the clicked label
    const labelIndex = Array.from(allLabels).indexOf(clickedLabel);
    
    // Find the corresponding option and toggle it
    if (allOptions[labelIndex]) {
      this.toggleProductOption(allOptions[labelIndex]);
    }
  }

  // Filter slider based on data-filter-value
  filterSlider(filterValue) {
    const productSliders = document.querySelectorAll('.product-slider');
    
    productSliders.forEach((slider) => {
      // Check if slider is initialized
      const isInitialized = $(slider).hasClass('slick-initialized');
      if (isInitialized) {
        // Always unfilter first to get back to the full dataset
        if (this.isFiltered) {
          $(slider).slick('slickUnfilter');
        }
        
        // If we have a filter value, apply the new filter
        if (filterValue) {
          // Create a filter selector for slides with matching data-filter-value
          const filterSelector = `[data-filter-value="${filterValue}"]`;
          
          // Check how many slides match the selector
          const matchingSlides = slider.querySelectorAll(filterSelector);
          
          if (matchingSlides.length === 0) {
            // Don't apply the filter if no slides match - this prevents empty track
            // Keep the slider unfiltered (showing all slides)
            this.isFiltered = false;
            this.currentFilter = null;
            return;
          }
          
          // Apply the new filter
          $(slider).slick('slickFilter', filterSelector);
          this.isFiltered = true;
          this.currentFilter = filterValue;
          
          // Set the first slide as active after filtering
          const currentSlides = slider.querySelectorAll('.slick-slide:not(.slick-cloned)');
          if (currentSlides.length > 0) {
            $(slider).slick('slickGoTo', 0);
          }
        } else {
          // No filter value, keep unfiltered
          this.isFiltered = false;
          this.currentFilter = null;
        }
        
        // After filtering, update button states for all visible cards
        // This ensures that cards that become visible have the correct button state
        const visibleCards = slider.querySelectorAll('.slider-card');
        visibleCards.forEach(card => {
          const variantId = card.dataset.variantId;
          const isSelected = this.selectedProducts.has(variantId);
          this.updateAddButtonState(card, isSelected);
        });
      }
    });
  }

  updateProgressBarsForActiveSlide(slider, currentSlide) {
    // Get the active slide element
    const activeSlide = slider.querySelectorAll('.slick-slide')[currentSlide];
    if (!activeSlide) return;
    
    // Check if the active slide IS the slider card (it has the slider-card class)
    const activeSliderCard = activeSlide.classList.contains('slider-card') ? activeSlide : activeSlide.querySelector('.slider-card');
    if (!activeSliderCard) return;
    
    // Find all progress bar fills in the slider's parent container
    const progressBarFills = slider.closest('.layout-slider').querySelectorAll('.progress-bar__fill');
    
    // Get the progress bar data from the active slide's data attributes
    const progressBarData = this.extractProgressBarDataFromSlide(activeSliderCard);
    
    // Check if values have changed from the previous slide
    const hasValuesChanged = this.hasProgressValuesChanged(progressBarFills, progressBarData);
    
    // Update each progress bar fill with the corresponding data from the active slide
    progressBarFills.forEach((progressBarFill, index) => {
      const progressValue = progressBarData[index];
      
      if (progressValue !== undefined) {
        // Update the progress bar fill
        progressBarFill.style.setProperty('--fill-width', progressValue);
        
        // Only trigger animation if values have changed
        if (hasValuesChanged) {
          progressBarFill.style.animation = 'none';
          progressBarFill.offsetHeight; // Force reflow
          progressBarFill.style.animation = 'fillProgress .5s ease forwards';
        }
      }
    });
  }

  extractProgressBarDataFromSlide(sliderCard) {
    // Get the progress values from the data attribute
    const progressValuesString = sliderCard.getAttribute('data-progress-values');
    
    if (!progressValuesString) {
      return [];
    }
    
    // Split the comma-separated values and add % to each
    const progressValues = progressValuesString.split(',').map(value => {
      const trimmedValue = value.trim();
      return trimmedValue ? `${trimmedValue}%` : '0%';
    });
    
    return progressValues;
  }

  hasProgressValuesChanged(progressBarFills, newProgressData) {
    // Compare current values with new values
    for (let i = 0; i < progressBarFills.length; i++) {
      const currentValue = progressBarFills[i].style.getPropertyValue('--fill-width');
      const newValue = newProgressData[i];
      
      // If any value is different, return true
      if (currentValue !== newValue) {
        return true;
      }
    }
    
    return false;
  }

  // Get country code from HTML data attribute
  getCountryCode() {
    return document.documentElement.dataset.countryCode || '';
  }

  // Check if current country is UK
  isUK() {
    return this.getCountryCode() === 'GB';
  }

  // Get currency code based on country (GBP for UK, EUR for others)
  getCurrencyCode() {
    return this.isUK() ? 'GBP' : 'EUR';
  }

  // Parse price from formatted string, handling European format (comma as decimal separator)
  parsePrice(priceString) {
    if (!priceString) return 0;

    // Remove currency symbols and whitespace
    let cleaned = priceString.replace(/[€£$]/g, '').trim();

    // Check if it uses comma as decimal separator (European format)
    // If there's a comma and it's followed by 1-2 digits at the end, it's likely a decimal separator
    const hasCommaDecimal = /,\d{1,2}$/.test(cleaned);

    if (hasCommaDecimal) {
      // European format: period is thousands separator, comma is decimal separator
      // Remove periods (thousands separators) and replace comma with period
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      // Standard format: remove all non-numeric characters except period
      cleaned = cleaned.replace(/[^0-9.]/g, '');
    }

    return parseFloat(cleaned) || 0;
  }

  // Format EUR with European format: €1.322,31
  formatEUR(amount) {
    // Format number with period as thousands separator and comma as decimal separator
    const parts = amount.toFixed(2).split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1];

    // Add thousands separators (period)
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Return format: €1.322,31
    return `€${formattedInteger},${decimalPart}`;
  }

  // Format price with proper currency formatting based on country
  // GBP for UK, EUR for all other countries
  formatCurrency(amount) {
    if (this.isUK()) {
      // UK - use GBP with standard formatting
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } else {
      // All other countries - use EUR with European format: €1.322,31
      return this.formatEUR(amount);
    }
  }

  // Update the apply button state
  updateApplyButton() {
    // Find the current modal
    let modal = document.querySelector('.customizer-product-modal[style*="block"]');
    
    // If not found with style selector, try finding visible modal
    if (!modal) {
      const allModals = document.querySelectorAll('.customizer-product-modal');
      modal = Array.from(allModals).find(m => m.style.display === 'block' || m.style.display !== 'none');
    }
    
    // If still not found, try finding modal that contains this slider
    if (!modal) {
      const slider = document.querySelector('.product-slider');
      if (slider) {
        modal = slider.closest('.customizer-product-modal');
      }
    }
    
    if (modal) {
      const applyBtn = modal.querySelector('.modal-apply-btn');
      if (applyBtn) {
        // Count grid selections in this modal
        const selectedOptionsInModal = modal.querySelectorAll('.customizer-product-option.selected')?.length || 0;
        
        // Count slider selections
        const selectedProductsInSlider = this.selectedProducts.size;
        
        // Check if there were initial selections when modal opened
        const modalId = modal.getAttribute('id');
        const hadInitialSelections = window.customizer?.initialSliderSelections?.get(modalId) || 0;
        
        // Enable button if there are any selections
        const hasAnySelections = selectedOptionsInModal > 0 || selectedProductsInSlider > 0 || hadInitialSelections.size > 0;
        applyBtn.disabled = !hasAnySelections;
      }
    }
  }
}

// Function to initialize the slider when a modal is opened
function initializeCustomizerCollectionModalSlider() {
  if (typeof $ !== 'undefined' && typeof $.fn.slick !== 'undefined') {
    if (!window.customizerCollectionModalSlider) {
      window.customizerCollectionModalSlider = new CustomizerCollectionModalSlider();
    }
  }
}

// Set up event listener for modal opening
document.addEventListener('DOMContentLoaded', function() {
  // Listen for clicks on customizer collection options
  document.addEventListener('click', function(event) {
    if (event.target.closest('.customizer-collection-option')) {
      // Initialize the slider when a modal is opened
      initializeCustomizerCollectionModalSlider();
    }
  });
});